export default "__VITE_ASSET__wC2XltGQ__"